<header mat-dialog-title class="header-title">
  <div class="header-title-content">
    <span *ngIf="coupon">Modifica Coupon: {{ coupon.name }}</span>
    <span *ngIf="!coupon" class="new-item">Nuovo Coupon</span>
  </div>
  
  <div class="header-actions" *ngIf="coupon">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteCoupon()">
        <mat-icon>delete</mat-icon>
        Elimina Coupon
      </button>
    </mat-menu>
  </div>
</header>

<mat-dialog-content>
  <form [formGroup]="couponsForm" novalidate>
    <!-- Nome e Codice -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Nome Coupon</mat-label>
        <input matInput formControlName="name" placeholder="Nome del Coupon" />
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Codice Coupon</mat-label>
        <input matInput formControlName="code" placeholder="Codice univoco" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>
    </div>

    <!-- Date di validità -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Data Inizio Validità</mat-label>
        <input matInput [matDatepicker]="pickerFrom" formControlName="startDate" placeholder="Seleziona Data">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Data Fine Validità</mat-label>
        <input matInput [matDatepicker]="pickerTo" formControlName="endDate" placeholder="Seleziona Data">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Tipologia di sconto e valore -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Tipologia di Sconto</mat-label>
        <mat-select formControlName="type">
          <mat-option value="percentage">Percentuale (%)</mat-option>
          <mat-option value="fixed">Importo Fisso (€)</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Valore dello Sconto</mat-label>
        <input matInput formControlName="discount" type="number" placeholder="Es. 10" />
      </mat-form-field>
    </div>

    <!-- Importo minimo e massimo dell'ordine -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Importo Minimo Ordine</mat-label>
        <input matInput formControlName="minimumOrderAmount" type="number" placeholder="Es. 50" />
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Importo Massimo Ordine</mat-label>
        <input matInput formControlName="maximumOrderAmount" type="number" placeholder="Es. 200" />
      </mat-form-field>
    </div>

    <!-- Numero massimo di utilizzi per utente -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Numero Massimo di Utilizzi per Utente</mat-label>
        <input matInput formControlName="maxUsesPerUser" type="number" placeholder="Es. 3" />
      </mat-form-field>
    </div>

    <!-- Nota per i clienti associati -->
    <!-- <p>Da aggiungere eventuali clienti associati che possono utilizzarlo</p> -->
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="left-actions">
    <span>
    <button mat-raised-button (click)="revert()" [disabled]="couponsForm.pristine">
      Reset
    </button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="couponsForm.pristine || !couponsForm.valid">
      Salva
    </button>
  </span>
  </div>
  <div class="right-actions">
    <button mat-raised-button (click)="close()">
    Chiudi
  </button>
  </div>
</mat-dialog-actions>
